import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppUsersDto } from '../model/app-users-dto';
import { LoggedInUserKeys, LoggedInUserService } from '../service/logged-in-user.service';

/** Roles that can never open an admin or super-admin screen. */
export const NON_ADMIN_ROLES = [
  'CANDIDATE',
  'FRACTAL_HR',
  'CLIENT_HR',
  'PROJECT_MANAGER',
  'COLLEGE_ADMIN',
];

/**
 * Opens the route only for a signed-in user whose role passes `isAllowed`; anyone
 * else gets `redirectTo`. Returns a UrlTree instead of navigating, so Angular runs
 * the redirect itself. Routing only - the backend still has to check the role.
 */
export const roleGuard =
  (isAllowed: (role: string) => boolean, redirectTo: string): CanActivateFn =>
  () => {
    const loggedInUserService = inject(LoggedInUserService);
    const user: AppUsersDto = loggedInUserService.getLoggedInUser(
      LoggedInUserKeys.LOGGED_IN_USER,
    );
    // isLoggedIn, not authToken: a cookie session keeps no token in storage.
    return (
      (loggedInUserService.isLoggedIn() && isAllowed(user.userRole)) ||
      inject(Router).parseUrl(redirectTo)
    );
  };

/** `isAllowed` for a fixed list of roles. */
export const oneOf =
  (...roles: string[]) =>
  (role: string) =>
    roles.includes(role);
